// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".plusdefault{display:none}", "",{"version":3,"sources":["/builds/boetzkes-it/w-care/app/javascript/css/site.scss"],"names":[],"mappings":"AAGA,aACE,YAAA","file":"site.scss","sourcesContent":["// app/javascript/css/site.scss\n\n// Hide plusdefault elements by default to prevent flash of content\n.plusdefault {\n  display: none;\n}\n\n\n\n"]}]);
// Exports
module.exports = exports;
